export const LAYOUT_TOGGLE_SIDEBAR = 'LAYOUT/TOGGLE_SIDEBAR'
export const LAYOUT_SHOW_SIDEBAR = 'LAYOUT/SHOW_SIDEBAR'
export const LAYOUT_HIDE_SIDEBAR = 'LAYOUT/HIDE_SIDEBAR'